import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

export enum ENotificationType {
  UNKNOWN = "Unknown Notification",
  WORKOUT_COMMENT = "Workout Comment",
  EXAM_PASSED = "Exam Passed",
  EXAM_FAILED = "Exam Failed",
  REQUEST_CANCELLED = "Workout Request Cancelled"
}

export const getTypeLabel = (
  type: racehorse360.NotificationType
): ENotificationType => {
  const {
    NotificationType: {
      NOTIFICATION_TYPE_WORKOUT_REQUEST_COMMENT_ADDED,
      NOTIFICATION_TYPE_HORSE_EXAM_PASSED,
      NOTIFICATION_TYPE_HORSE_EXAM_FAILED,
      NOTIFICATION_TYPE_WORKOUT_REQUEST_CANCELLED
    }
  } = racehorse360;

  switch (type) {
    case NOTIFICATION_TYPE_WORKOUT_REQUEST_COMMENT_ADDED:
      return ENotificationType.WORKOUT_COMMENT;
    case NOTIFICATION_TYPE_HORSE_EXAM_PASSED:
      return ENotificationType.EXAM_PASSED;
    case NOTIFICATION_TYPE_HORSE_EXAM_FAILED:
      return ENotificationType.EXAM_FAILED;
    case NOTIFICATION_TYPE_WORKOUT_REQUEST_CANCELLED:
      return ENotificationType.REQUEST_CANCELLED;
    default:
      return ENotificationType.UNKNOWN;
  }
};
